import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';

const PdfViewerWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
  position: relative;

  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding-bottom: 60px; /* Space for page info */
  }

  .pdf-page {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background: ${COLOR_WHITE};
  }

  .react-pdf__Page__canvas {
    max-width: 100%;
    height: auto !important;
  }

  .react-pdf__Page__textContent {
    max-width: 100%;
  }

  .react-pdf__Page__annotations {
    max-width: 100%;
  }

  .pdf-loading,
  .pdf-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    text-align: center;
    color: #666;
  }

  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .pdf-page-info {
    position: sticky;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: ${COLOR_WHITE};
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    text-align: center;
    pointer-events: none;
    margin-top: 20px;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
`;

export default PdfViewerWrapper;

